<div class="factor-editor"
     [class.in-edit-mode]="editing"
     [class.not-edit-mode]="!editing">
  <div class="top-factor-icons">
    <i class="fa fa-trash" (click)="onDeleteMe()" genTooltip [tooltipPosition]="'BOTTOM'" [appendToBody]="true" [tooltipText]="'Delete'" [tooltipShow]="true"></i>
    <i class="fa fa-clone" (click)="onCloneMe()" genTooltip [tooltipPosition]="'BOTTOM'" [appendToBody]="true" [tooltipText]="'Clone'" [tooltipShow]="true"></i>
    <i class="fa fa-bars" genTooltip [tooltipPosition]="'BOTTOM'" [appendToBody]="true" [tooltipText]="'Drag to change priority'" [tooltipShow]="true"></i>
  </div>
  <div class="clickable" (click)="editQuery()">
    <div *ngFor="let rep of representation">
      {{rep}}<br/>
    </div>
  </div>
</div>
